<div class="filter-bar">
    <button
        appLocalizationPopupDirective
        localizationCode="AddFilter"
        mat-stroked-button
        class="filter-bar__add"
        [class.filter-bar__add--active]="filters.length > 0"
        type="button"
        appPreventDoubleClick (throttledClick)="openFilterDialog()"
    >
        <mat-icon aria-hidden="true" class="material-icons-outlined">filter_list</mat-icon>
        <span>{{ 'AddFilter' | translate: {Default: "Add Filter"} }}</span>
        <span class="filter-bar__count" *ngIf="filters.length > 0">{{ filters.length }}</span>
    </button>

    <div class="filter-pill" *ngFor="let filter of filters">
        <button
            type="button"
            class="filter-pill__body"
            [matTooltip]="'Edit' | translate: {Default: 'Edit'}"
            appPreventDoubleClick (throttledClick)="openFilterDialog(filter)"
        >
            <span class="filter-pill__category">{{ filter.filterCategory?.title }}</span>
            <span class="filter-pill__operator">
                <ng-container *ngIf="operatorLabels[filter.filterOperator]; else rawOperator">{{ operatorLabels[filter.filterOperator] | translate }}</ng-container>
                <ng-template #rawOperator>{{ filter.filterOperator }}</ng-template>
            </span>
            <span class="filter-pill__value">
                <ng-container *ngIf="filter.filterCategory?.dataType === 'Percentage'; else notPercentage">{{ convertToNumber(filter.filterString) }}%</ng-container>

                <ng-template #notPercentage>
                    <ng-container *ngIf="filter.filterCategory?.dataType === 'Boolean'; else notBoolean">{{ convertBooleanToText(filter.filterString) }}</ng-container>
                    <ng-template #notBoolean>
                        <ng-container *ngIf="filter.filterString.text">{{ filter.filterString.text }}</ng-container>
                        <ng-container *ngIf="filter.filterString.name">{{ filter.filterString.name }}</ng-container>
                        <ng-container *ngIf="!filter.filterString.text && !filter.filterString.name">{{ filter.filterString }}</ng-container>
                    </ng-template>
                </ng-template>
            </span>
        </button>

        <button
            type="button"
            class="filter-pill__remove"
            appLocalizationPopupDirective
            localizationCode="Delete"
            [attr.aria-label]="'Delete' | translate: {Default: 'Delete'}"
            appPreventDoubleClick (throttledClick)="deleteFilter(filter)"
        >
            <mat-icon aria-hidden="true" class="material-icons-outlined">close</mat-icon>
        </button>
    </div>

    <button
        appLocalizationPopupDirective
        localizationCode="ClearFilters"
        mat-button
        type="button"
        class="filter-bar__clear"
        *ngIf="filters.length > 1"
        appPreventDoubleClick (throttledClick)="clearFilters()"
    >
        {{ 'ClearFilters' | translate: {Default: "Clear Filters"} }}
    </button>
</div>
